<template>
    <div class="words">
        <h1>WORDS Page done</h1>
    </div>
</template>

<script>
    export default {
        name: "Words"
    }
</script>

<style scoped>

</style>